export default __webpack_public_path__ + "static/media/Copiar.f6600dc2.svg";